import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-Contact-us",
  templateUrl: "./Contact-us.component.html",
  styleUrls: ["./contact-us.component.css"]
})
export class ContactUsComponent implements OnInit {
  lang: any;
  constructor() {}

  ngOnInit() {
    this.lang = localStorage.getItem("lang");
  }
}
